export default {"src":"/org/_next/static/media/error.3c75cf41.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};